// extracted by mini-css-extract-plugin
export default {"root":"SyMfSul2V6PlXtuk7peJ","btns":"xz3pFwriBK0UZ487Tn04","btn":"QpALWnkxln9cVRHEoJQb"};